import Table from '@/common/components/Table'
import { useFilterParams } from '@/common/hooks/useFilterParams'
import { Mapper } from '@/common/services/mapper'
import { cn } from '@/common/utils/cn'
import { CreateGovernmentAllocationEntryModal } from '@/features/privateCompanies/components/CreateGovernmentAllocationReinforcementModal'
import { useCompanyGovernmentAllocationEntries } from '@/features/privateCompanies/hooks/useCompanyGovernmentAllocationEntries'
import { governmentAllocationDocumentsTableColumns } from '@/features/privateCompanies/pages/CompanyGovernmentAllocations/Show/constants/governmentAllocationDocumentsTableColumns'
import { CompanyGovernmentAllocationDocumentsTransformer } from '@/features/privateCompanies/services/companyGovernmentAllocationDocumentsTransformer'
import { CompanyGovernmentAllocationData } from '@/features/privateCompanies/types/companyGovernmentAllocation.type'
import { useParams } from 'react-router-dom'

type GovernmentAllocationDocumentsProps = {
  companyGovernmentAllocation: CompanyGovernmentAllocationData
  showReinforcementButton: boolean
  disableReinforcement: boolean
}

export const GovernmentAllocationDocuments = ({
  companyGovernmentAllocation,
  showReinforcementButton,
  disableReinforcement,
}: GovernmentAllocationDocumentsProps) => {
  const { companyId } = useParams()

  const { filterParams, setFilterParams } = useFilterParams()

  const {
    data: companyGovernmentAllocationEntries,
    isLoading: companyGovernmentAllocationEntriesIsLoading,
    meta,
  } = useCompanyGovernmentAllocationEntries({
    governmentAllocationId: companyGovernmentAllocation.id,
    filters: {
      page: filterParams.page || 1,
    },
    mapper: Mapper.mapWithTransformer({
      transformer: CompanyGovernmentAllocationDocumentsTransformer.tableTransformer(companyId || ''),
    }),
  })

  return (
    <div className="flex flex-col gap-6">
      {showReinforcementButton && (
        <div className="self-end">
          <CreateGovernmentAllocationEntryModal
            governmentAllocationId={companyGovernmentAllocation.id}
            disabled={disableReinforcement}
          />
        </div>
      )}

      <Table
        className={cn(
          'min-h-[256px]',
          companyGovernmentAllocation.controlled_by === 'quantity'
            ? 'max-h-[calc(100vh-432px)]'
            : 'max-h-[calc(100vh-496px)]',
        )}
        columns={governmentAllocationDocumentsTableColumns}
        rows={companyGovernmentAllocationEntries}
        hasPagination
        page={filterParams.page || 1}
        setPage={(page) => setFilterParams((prev) => ({ ...prev, page }))}
        totalCount={meta.total}
        totalPages={meta.total_pages}
        isLoadingData={companyGovernmentAllocationEntriesIsLoading}
        loadingRows={2}
        rowEmptyValue="--"
      />
    </div>
  )
}
